<td
  (click)="selectRow.emit(rowIndex)"
  class="row-num sticky"
  title="Click to select row"
>
  {{ rowIndex + 1 }}
</td>

@for (cell of tableCells; track cell; let i = $index) { @if
(!cell.question.hidden && !cell.question.toggleOff) {
<td
  (click)="cellClick(cell)"
  class="{{ determineHighestLock(cell.question.lockType) }}"
  id="{{ 'question-table-warning-' + cell.question.id + '-' + cell.answer.id }}"
  [ngClass]="{
    highlighted: cell.answer.overrideStatus || cell.answer.answerChanged,
    active: cell.answer?.isActive,
    error: hasMandatoryWarning(cell),
    'grey-out': cell.question.actualHidden,
    'active-warning':
      hasMandatoryWarning(cell) ||
      cell.formControl?.valid === false ||
      hasWarnings(cell.answer, true),
    'checkbox-column': cell.question.isBooleanCheckbox,
    nonEmpty: cell.answer.overrideStatus || cell.answer.answerChanged,
    lock:
      isLocked[i] &&
      (cell.question.lockType === 'hardLock' ||
        cell.question.lockType === 'softLock'),
    unlock: !isLocked[i]
  }"
  (mouseover)="hover.emit(i)"
  (mouseleave)="leave.emit()"
>
  @if (!cell.answer?.isActive) {
  <div class="answer" [ngClass]="{ checkbox: cell.question.isBooleanCheckbox }">
    @if (!cell.question.isBooleanCheckbox) {
    <div
      class="value"
      [class.right]="
        cell.question.dataType.toLowerCase() === 'integer' ||
        cell.question.dataType.toLowerCase() === 'float'
      "
      appTooltip
      [showOnTruncate]="true"
      [content]="cell.formControl?.value"
    >
      {{ cell.question | answerDisplay: cell.displayAnswer }}
    </div>
    } @if (cell.question.isBooleanCheckbox) { @if ( cell.formControl ?
    cell.formControl.value : cell.answer.answer === 'true' ) {
    <div class="blue tick icon"></div>
    } @if ( cell.formControl ? !cell.formControl?.value : cell.answer.answer !==
    'true' ) {
    <div class="grey circle outline icon"></div>
    } }
    <div class="dots">
      @if ( hasMandatoryWarning(cell) || cell.formControl?.valid === false ||
      hasWarnings(cell.answer, false) ) {
      <div
        [ngClass]="{
          active:
            hasMandatoryWarning(cell) ||
            cell.formControl?.valid === false ||
            hasWarnings(cell.answer, true)
        }"
        class="dot warning"
      ></div>
      } @if (hasFlags(cell.answer, false)) {
      <div
        [ngClass]="{ active: hasFlags(cell.answer, true) }"
        class="dot flag"
      ></div>
      } @if (hasComments(cell.answer)) {
      <div class="dot comment"></div>
      }
    </div>
    @if ( !isQuestionAlwaysEditable(cell.question, readonlyGlobal || deleted) )
    {
    <div class="hover-options">
      @if (!inspectMode && !cell.question.isBooleanCheckbox && !isLocked[i]) {
      <i class="pencil icon"></i>
      } @if (!inspectMode) {
      <i
        class="icon comment alternate outline"
        (click)="
          labelClick(cell.question, cell.answer, cell); $event.stopPropagation()
        "
      ></i>
      } @if (inspectMode && inspectMode === 'flag') {
      <i class="icon flag orange outline"></i>
      } @if (inspectMode && inspectMode === 'trace') {
      <i class="icon question black"></i>
      }
    </div>
    }
  </div>
  } @if ( cell.answer?.isActive && cell.formControl &&
  !isQuestionAlwaysEditable(cell.question, readonlyGlobal || deleted) ) {
  <div>
    <app-form-field-wrapper
      (clickOutside)="onCellBlur(cell)"
      [delayClickOutsideInit]="true"
      [formGroup]="formGroup"
      [groupId]="groupId"
      [questions]="subGroup?.questions"
      [question]="cell.question"
      [row]="rowIndex"
      [disabled]="
        isQuestionAlwaysEditable(cell.question, readonlyGlobal || deleted)
      "
      [autofocus]="true"
    ></app-form-field-wrapper>
  </div>
  } @if ((cell.question.lockType === 'manualInput' || !isLocked[i]) &&
  showOverRideQuestion(cell.answer) ) {
  <i class="eraser icon" (click)="overRideAnswer(cell.answer, cell)"></i>
  }
</td>
} }
